import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';

import { cn } from '../lib/utils.js';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // ENG-3054 D7: the indeterminate (mixed) state gets the SAME primary fill as
      // checked, so a partially-selected group checkbox reads as filled rather than
      // as an empty box with a stray glyph. The NAMED group (`group/checkbox`) lets
      // the Indicator glyphs pick themselves from THIS Root's Radix data-state
      // (below) rather than from a prop or from an unrelated ancestor `.group`.
      'group/checkbox peer h-4 w-4 shrink-0 rounded-sm border border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:shadow-[var(--shadow-focus)] disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
      {/* ENG-3054 D7: Radix renders the Indicator for BOTH checked and
          indeterminate. Render both glyphs and switch on the REAL Radix state
          (data-state on the named `group/checkbox` Root), not on `props.checked` —
          so an UNCONTROLLED `defaultChecked="indeterminate"` still shows a Minus,
          and every existing mixed checkbox (useInvoiceSelection, OrdersListPage,
          AssignmentBoard) renders a Minus rather than a Check. */}
      <Check className="h-4 w-4 group-data-[state=indeterminate]/checkbox:hidden" />
      <Minus className="hidden h-4 w-4 group-data-[state=indeterminate]/checkbox:block" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
